import axiosInstance from '../api/axios';

//added to push the code
export const getAllSubmissions = async (id) => {
    try {
        const response = await axiosInstance.get(`/getSubmissionsByStudentId?studentId=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};

export const getAllSubmissions1 = async (id) => {
    try {
        const response = await axiosInstance.get(`/getSubmissionsByStudentId1?studentId=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};

export const getNextReportType = async (id) => {
    try {
        const response = await axiosInstance.get(`/getNextReportTypeByStudentId?studentId=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};
